import { render, staticRenderFns } from "./CalendarSynchronizationHasBroken.vue?vue&type=template&id=17621166"
import script from "./CalendarSynchronizationHasBroken.vue?vue&type=script&lang=js"
export * from "./CalendarSynchronizationHasBroken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports